import { jsx as _jsx } from "react/jsx-runtime";
import { ListGroup } from "banafo-design-system";
import ActivitiesItem from "src/features/activityLog/ActivitiesItem";
import "./ActivitiesList.scss";
const ActivitiesList = ({ activities }) => {
    return (_jsx(ListGroup, { as: "ul", variant: "flush", className: "activities w-100", children: activities.map((activity) => _jsx(ActivitiesItem, Object.assign({}, activity), activity.id)) }));
};
export default ActivitiesList;
